import { render, staticRenderFns } from "./PendingCollectionModal.vue?vue&type=template&id=8efbc9f2&scoped=true"
import script from "./PendingCollectionModal.vue?vue&type=script&lang=js"
export * from "./PendingCollectionModal.vue?vue&type=script&lang=js"
import style0 from "./PendingCollectionModal.vue?vue&type=style&index=0&id=8efbc9f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efbc9f2",
  null
  
)

export default component.exports